export function formatToBRLCurrency(value: string) {
    const numberReturn = Number(value).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
    });

    return numberReturn;
}